import {styled} from '@mui/material/styles'
import {Chip} from '@mui/material'

export const StyledChip = styled(Chip)(({theme}) => ({
  backgroundColor: theme.palette.common.grey4,
  margin: '10px 10px 0 0'
}))
